export default __webpack_public_path__ + "static/media/mint-video.5bbca027.webm";